var map = {
	"./ge2020-logo.svg": "36a5",
	"./project/close.svg": "b44b",
	"./project/constituencies/aljunied-grc.jpg": "b20e",
	"./project/constituencies/ang-mo-kio-grc.jpg": "2556",
	"./project/constituencies/bishan-toa-payoh-grc.jpg": "4b54",
	"./project/constituencies/bukit-batok-smc.jpg": "54ae",
	"./project/constituencies/bukit-panjang-smc.jpg": "366d",
	"./project/constituencies/chua-chu-kang-grc.jpg": "97fc",
	"./project/constituencies/east-coast-grc.jpg": "bb02",
	"./project/constituencies/holland-bukit-timah-grc.jpg": "0ed8",
	"./project/constituencies/hong-kah-north-smc.jpg": "9bc7",
	"./project/constituencies/hougang-smc.jpg": "0956",
	"./project/constituencies/jalan-besar-grc.jpg": "83c0",
	"./project/constituencies/jurong-grc.jpg": "ab49",
	"./project/constituencies/kebun-baru-smc.jpg": "84e9",
	"./project/constituencies/macpherson-smc.jpg": "e4fb",
	"./project/constituencies/marine-parade-grc.jpg": "9d10",
	"./project/constituencies/marsiling-yew-tee-grc.jpg": "06a4",
	"./project/constituencies/marymount-smc.jpg": "3cd9",
	"./project/constituencies/mountbatten-smc.jpg": "49e4",
	"./project/constituencies/nee-soon-grc.jpg": "4d2b",
	"./project/constituencies/pasir-ris-punggol-grc.jpg": "03a5",
	"./project/constituencies/pioneer-smc.jpg": "0be6",
	"./project/constituencies/potong-pasir-smc.jpg": "433e",
	"./project/constituencies/punggol-west-smc.jpg": "f982",
	"./project/constituencies/radin-mas-smc.jpg": "e5d1",
	"./project/constituencies/sembawang-grc.jpg": "e23e",
	"./project/constituencies/sengkang-grc.jpg": "003c",
	"./project/constituencies/tampines-grc.jpg": "8737",
	"./project/constituencies/tanjong-pagar-grc.jpg": "55f1",
	"./project/constituencies/west-coast-grc.jpg": "c7079",
	"./project/constituencies/yio-chu-kang-smc.jpg": "1f24",
	"./project/constituencies/yuhua-smc.jpg": "c828",
	"./project/cross-icon.svg": "d5c5",
	"./project/down-arrow.svg": "d588",
	"./project/flag.svg": "6934",
	"./project/pin.svg": "f500",
	"./project/search-icon.svg": "a1cf",
	"./project/stylised-images/cooling-off-day.jpg": "0acd",
	"./project/stylised-images/default-image.jpg": "a292",
	"./project/stylised-images/nomination-day-centres-open.jpg": "701e",
	"./project/stylised-images/nomination-day-final-objections-deadline.jpg": "3d01",
	"./project/stylised-images/nomination-day-form-submissions.jpg": "0484",
	"./project/stylised-images/party-dpp.jpg": "44a5",
	"./project/stylised-images/party-ind.jpg": "22c6",
	"./project/stylised-images/party-nsp.jpg": "32c5",
	"./project/stylised-images/party-pap.jpg": "ea84",
	"./project/stylised-images/party-ppp.jpg": "7c3f",
	"./project/stylised-images/party-psp.jpg": "a612",
	"./project/stylised-images/party-pv.jpg": "de21",
	"./project/stylised-images/party-rdu.jpg": "58d1",
	"./project/stylised-images/party-rp.jpg": "b012",
	"./project/stylised-images/party-sda.jpg": "aa4b",
	"./project/stylised-images/party-sdp.jpg": "8619",
	"./project/stylised-images/party-singfirst.jpg": "27e4",
	"./project/stylised-images/party-spp.jpg": "fc34",
	"./project/stylised-images/party-wp.jpg": "d9c4",
	"./project/stylised-images/polling-day-polls-open.jpg": "0596",
	"./project/stylised-images/results-released.jpg": "f759",
	"./project/stylised-images/sample-count-released.jpg": "7676",
	"./project/stylised-images/writ-of-election-issued.jpg": "439c",
	"./project/up-arrow.svg": "449c",
	"./project/user.svg": "116d",
	"./template/image-background-header-desktop.jpg": "5c5b",
	"./template/image-background-header.jpg": "32e0",
	"./template/sample-image-desktop.png": "3100",
	"./template/sample-image.png": "da96",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";